<template>
  <BCard>
    <!-- Header Section -->
    <div class="mb-2 flex flex-row justify-between items-center">
      <div class="text-black font-semibold text-xl">
        Dashboard Komads
      </div>
      <div class="w-[120px]">
        <FlatPickr
          v-model="period"
          :config="configDate"
          class="custom-select"
        />
      </div>
    </div>

    <!-- Balance & Total Registrasi Section -->
    <div class="card border p-[1.5rem] col-12 mb-[.5rem] bg-revenue">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-[1rem] mb-[50px] rounded-xl bg-[#F5F5F5] border p-[1rem] w-full">
        <div
          v-for="(item, index) in balanceList"
          :key="index"
        >
          <Card
            :title="getBalanceTitle(item)"
            :loading="loading[`balance_${item.account_type.toLowerCase()}`]"
            :item="item"
            :on-click="() => getMonit(item.account_type)"
            :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/rotate-left-1.svg'"
            :tooltip="getBalanceTooltip(item)"
            :source="'balances'"
          >
            <template #extra-content>
              <div class="flex gap-[1rem] mt-[.5rem]">
                <BButton
                  variant="outline-link"
                  tag="router-link"
                  :to="{ name: 'topup-history-komads', params: { 'account-type': item.account_type } }"
                  class="!text-black border"
                >
                  Riwayat
                </BButton>
                <BButton
                  variant="primary"
                  @click="() => {
                    selectedBalance = item
                    $bvModal.show('modal-topup-balance-monit')
                  }"
                >
                  Top Up
                </BButton>
              </div>
            </template>
          </Card>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-[1rem] bg-[#F5F5F5] border p-[1rem] border rounded-xl">
        <!-- User CTWA Card -->
        <CardRegistration
          v-for="item in data.userInfo"
          :key="item.title"
          :title="item.title"
          :total="item.value"
          :description="item.value"
          :registration-data="data.registrationData"
        >
          <template #children>
            <ApexCharts
              v-if="item.detail_value"
              ref="accountChart"
              height="100"
              type="bar"
              class="mt-[-40px] ml-[-24px]"
              :options="chartAreaOptions"
              :series="buildSeries(item.detail_value, item.title)"
            />
            <span
              v-else
              class="block text-base md:text-lg"
            >{{
              item.secondary_value
            }}</span>
          </template>
        </CardRegistration>
      </div>
    </div>

    <!-- Spending Section -->
    <div
      class="flex flex-col gap-4 bg-white border border-[#E5E5E5] rounded-[8px] p-2"
    >
      <!-- Platform Tabs -->
      <div class="flex flex-col gap-4 mb-2">
        <div class="flex flex-row justify-between items-center">
          <div class="text-black font-semibold text-lg">
            Data Spending Partner
          </div>
          <div class="flex items-center gap-3">
            <VSelect
              v-model="selectedFilter"
              :options="filterOptions"
              :clearable="false"
              :searchable="false"
              label="text"
              class="!w-[160px]"
            />
          </div>
        </div>

        <!-- Platform Tab Buttons -->
        <div class="flex flex-wrap gap-[1rem]">
          <button
            v-for="platform in platformOptions"
            v-show="selectedFilter.value === 'whitelist'"
            :key="platform.value"
            :class="[
              'px-4 py-[12px] rounded-full text-lg font-medium transition-all duration-200',
              'focus:outline-none focus:ring-2 focus:ring-offset-2',
              selectedPlatform.value === platform.value
                ? 'bg-[#FF5722] text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            ]"
            @click="selectedPlatform = platform"
          >
            {{ platform.text }}
          </button>
        </div>
      </div>
      <div
        class="grid gap-4"
        :class="[
          data.analyticSpendingCards.length > 2 ? 'md:grid-cols-3' : 'md:grid-cols-2'
        ]"
      >
        <AnalyticSpendingCard
          v-for="card in data.analyticSpendingCards"
          :key="card.title"
          :data="card"
        />
      </div>

      <BRow>
        <BCol lg="12">
          <Chart
            :series="data.spendingPerDay"
            :loading="loading.spendingChart"
            :options="chartOptions"
          />
        </BCol>
        <BCol lg="12">
          <div class="text-black font-semibold text-lg my-1">
            Leaderboard Partner
          </div>
          <div class="border rounded-[8px] overflow-hidden">
            <Table
              :loading="loading.tableData"
              :items="data.topPartner"
              :table-type="selectedFilter.value"
              :platform="selectedPlatform.value"
            />
          </div>
        </BCol>
      </BRow>
    </div>

    <ModalTopupBalanceMonit
      ref="modal-topup-balance-monit"
      :account-type="selectedBalance.account_type"
      @topup="handleTopupData"
      @on-cancel="selectedBalance = {}"
    />

    <ModalPIN
      id="modal-pin"
      ref="modal-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Masukkan nominal topup dan VA bank tujuan kamu, dan pastikan VA sesuai yang kamu tuju"
      label-confirm-button="Submit"
      label-cancel-button="Batal"
      @on-cancel-button="handleCancelPin"
      @on-confirm-button="topupBalanceMonit"
    />
  </BCard>
</template>

<style scoped>
::v-deep .btn-primary,
::v-deep .btn-outline-link {
  border-radius: 10px !important;
}
::v-deep .btn-outline-link {
  border: solid 1.5px #E5E5E5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}
</style>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import {
  DATE,
  LABELMONTH, MONTH_YEAR, START_DATE_OF_MONTH,
} from '@/libs/filterDate'
import FlatPickr from 'vue-flatpickr-component'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import VSelect from 'vue-select'
import ApexCharts from 'vue-apexcharts'
import Chart from '../components/Chart.vue'
import Table from './Table.vue'
import CardRegistration from './CardRegistration.vue'
import { chartAreaOptions, chartOptions } from './config'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import '@core/scss/vue/libs/vue-select.scss'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import Card from './Card.vue'
import ModalTopupBalanceMonit from './ModalTopupBalanceMonit.vue'
import AnalyticSpendingCard from './AnalyticSpendingCard.vue'

export default {
  components: {
    Chart,
    Table,
    ApexCharts,
    CardRegistration,
    FlatPickr,
    VSelect,
    Card,
    ModalTopupBalanceMonit,
    ModalPIN,
    AnalyticSpendingCard,
  },
  data() {
    return {
      period: START_DATE_OF_MONTH(new Date()),
      monthlabel: LABELMONTH,
      IDR,
      chartOptions,
      chartAreaOptions,
      selectedFilter: { text: 'Whitelisted', value: 'whitelist' },
      filterOptions: [
        // { text: 'CTWA', value: 'ctwa' },
        { text: 'Whitelisted', value: 'whitelist' },
      ],
      selectedPlatform: { text: 'Meta', value: 'meta' },
      platformOptions: [
        { text: 'Meta', value: 'meta' },
        { text: 'Google', value: 'google' },
        { text: 'TikTok', value: 'tiktok' },
      ],
      data: {
        balance: [],
        registrationData: undefined,
        userInfo: [],
        spendingChart: undefined,
        topPartner: [],
        spendingPerDay: [],
        analyticSpendingCards: [],
      },
      loading: {
        balance_general: false,
        balance_bcad: false,
        userInfo: false,
        spendingChart: false,
        tableData: false,
      },
      configDate: {
        mode: 'single',
        locale: Indonesian,
        altInput: true,
        altFormat: 'j/n/Y',
        dateFormat: 'Y-m-d',
        maxDate: new Date(),
        plugins: [
          new MonthSelect({
            shorthand: true,
            dateFormat: 'Y-m-d',
            altFormat: 'M Y',
          }),
        ],
      },
      platformColors: {
        google: '#FFC55A',
        meta: '#03AED2',
        tiktok: '#FC4100',
      },
      topupData: null,
      selectedBalance: {},
    }
  },
  computed: {
    badgeClass() {
      return this.data.userInfo.some(item => item.percentage_registration > 0)
        ? 'increased-revenue'
        : 'decreased'
    },
    balanceList() {
      if (Array.isArray(this.data.balance) && this.data.balance.length > 0) {
        return this.data.balance
      }
      return [
        { account_type: 'GENERAL', display_name: 'Operations', balance: 0 },
        { account_type: 'BCAD', display_name: 'BCA Digital', balance: 0 },
      ]
    },
  },
  watch: {
    period: {
      handler() {
        this.getUserInfo()
        this.getSpendingChart()
        this.getTopPartner()
      },
    },
    selectedFilter: {
      handler() {
        this.getSpendingChart()
        this.getTopPartner()
      },
    },
    selectedPlatform: {
      handler() {
        this.getSpendingChart()
        this.getTopPartner()
      },
    },
  },
  mounted() {
    this.loadAllData()
  },
  methods: {
    /**
     * Load all dashboard data
     */
    loadAllData() {
      this.getMonit()
      this.getUserInfo()
      this.getSpendingChart()
      this.getTopPartner()
    },
    /**
     * Builds a series of data for the ApexCharts component
     * given a list of platform details
     * @param {Object[]} details - List of user info details
     * @param {String} title - Title of the series
     * @returns {Object[]} A series of data for the ApexCharts component
     */
    buildSeries(details, title) {
      return details.map(d => ({
        name:
          d.platform_name.charAt(0).toUpperCase() + d.platform_name.slice(1),
        data: [d.value],
        color: this.platformColors[d.platform_name],
        currentValue: d.current_value,
        title,
      }))
    },
    /**
     * Get user info data for the selected period
     * Using mock data for development
     */
    async getUserInfo() {
      this.loading.userInfo = true
      const month = MONTH_YEAR(this.period)
      const url = '/komads/api/v1/admin/dashboard/user_info'
      const response = await newAxiosIns.get(url, {
        params: {
          month,
        },
      })
      const { data } = response.data

      this.data.registrationData = data
      this.data.userInfo = data.user_info_data
      this.loading.userInfo = false
    },

    /**
     * Get spending chart data based on selected filter and platform
     */
    async getSpendingChart() {
      this.loading.spendingChart = true
      const month = MONTH_YEAR(this.period)
      const url = '/komads/api/v1/admin/dashboard/spend_analytic'
      const response = await newAxiosIns.get(url, {
        params: {
          month,
          type: this.selectedFilter.value,
          platform_name: this.selectedPlatform.value,
        },
      })
      const { data } = response.data

      this.data.spendingChart = data
      this.data.spendingPerDay = [
        {
          name: 'Total Spending',
          data: data.spending_per_day.map(item => ({
            x: item.date,
            y: item.total_spending,
          })),
        },
      ]
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: data.spending_per_day.map(item => DATE(item.date)),
          min: data.spending_per_day.map(item => item.date),
        },
      }
      this.getAnalyticSpendingCards(this.data.spendingChart)
      this.loading.spendingChart = false
    },
    /**
     * Get analytic spending cards data based on selected platform
    */
    getAnalyticSpendingCards(data) {
      this.data.analyticSpendingCards = [
        {
          title: 'Total Spending',
          tooltip: 'Total spending seluruh akun whitelisted partner pada periode yang dipilih, dan direset setiap awal bulan',
          count: IDR(data.total_spending),
          growth: data.total_spending_percentage,
        },
        {
          title: 'Minggu Lalu',
          tooltip: 'Total spending selama 7 hari terakhir',
          count: IDR(data.total_spending_last_week),
        },
      ]

      if (this.selectedPlatform.value === 'meta') {
        this.data.analyticSpendingCards.push(
          {
            title: 'Revenue',
            tooltip: 'Total penghasilan bersih pada periode yang dipilih',
            count: IDR(data.revenue),
            growth: data.revenue_percentage,
          },
          {
            title: 'Total Revenue Provider',
            tooltip: 'Total penghasilan bersih yang didapatkan provider periode yang dipilih',
            count: IDR(data.revenue_provider),
          },
          {
            title: 'Total PPN',
            tooltip: 'Total nilai Pajak Pertambahan Nilai (PPN) yang telah dibayarkan pada periode yang dipilih',
            count: IDR(data.total_ppn),
          },
          {
            title: 'Rata-rata Top Up Fee Partner',
            tooltip: 'Nilai rata-rata top up fee dari seluruh partner yang memiliki akun Meta',
            count: `${data.average_top_up_fee}%`,
          },
        )
      }
    },

    /**
     * Get data top partner based on selected filter and platform
     */
    async getTopPartner() {
      this.loading.tableData = true
      const month = MONTH_YEAR(this.period)
      const url = '/komads/api/v1/admin/dashboard/top_partner'
      const response = await newAxiosIns.get(url, {
        params: {
          month,
          type: this.selectedFilter.value,
          platform_name: this.selectedPlatform.value,
        },
      })
      this.data.topPartner = response.data.data
      this.loading.tableData = false
    },
    /**
     * Get monit balances from the API.
     * Optionally fetches balance for a specific account type.
     * @param {String|null} accountType - The specific account type to fetch (e.g., 'GENERAL', 'BCAD'), or null to fetch all.
     */
    async getMonit(accountType = null) {
      const type = accountType?.toLowerCase()
      try {
        const url = '/komads/api/v1/admin/monit/balance'
        const params = {}
        if (type) {
          params.type = type
          this.loading[`balance_${type}`] = true
        } else {
          this.loading.balance_general = true
          this.loading.balance_bcad = true
        }
        const { data: { data } } = await newAxiosIns.get(url, { params })
        if (type) {
          const selectedBalanceIndex = this.data.balance.findIndex(item => item.account_type === type)
          const [newestBalance] = data
          this.data.balance[selectedBalanceIndex] = newestBalance
          return
        }
        this.data.balance = data
      } catch {
        this.$toast_error({ title: 'Gagal', message: 'Gagal memproses permintaan, silakan coba beberapa saat lagi' })
      } finally {
        if (type) {
          this.loading[`balance_${type}`] = false
        } else {
          this.loading.balance_general = false
          this.loading.balance_bcad = false
        }
      }
    },
    /**
     * Gets the display title for a given balance item.
     * @param {Object} item - The balance item object containing account details.
     * @returns {String} The formatted title for the balance account.
     */
    getBalanceTitle(item) {
      if (item.account_type === 'GENERAL') {
        return 'Main Balance'
      }
      if (item.account_type === 'BCAD') {
        return 'Saldo BCA Digital'
      }
      return item.display_name || item.account_type || 'Balance'
    },
    /**
     * Gets the tooltip description for a given balance item.
     * @param {Object} item - The balance item object containing account details.
     * @returns {String} The tooltip text providing more context about the balance.
     */
    getBalanceTooltip(item) {
      if (item.account_type === 'GENERAL') {
        return 'Saldo Komerce di Monit'
      }
      if (item.account_type === 'BCAD') {
        return 'Saldo aktif BCA Digital yang tersedia untuk pembayaran iklan.'
      }
      return ''
    },
    handleTopupData(payload) {
      this.topupData = payload
      this.$bvModal.hide('modal-topup-balance-monit')
      this.$bvModal.show('modal-pin')
    },
    handleCancelPin() {
      this.topupData = null
      this.$bvModal.show('modal-topup-balance-monit')
      this.$bvModal.hide('modal-pin')
    },

    async topupBalanceMonit() {
      const { nominal, destination_account_id } = this.topupData

      await newAxiosIns.post('/komads/api/v1/admin/monit/topup', {
        pin: this.$refs['modal-pin'].PIN,
        nominal,
        destination_account_id,
      })
        .then(() => {
          this.$toast_success({ title: 'Berhasil', message: `Topup saldo ${IDR(nominal)} berhasil` })
          this.getMonit(this.selectedBalance.account_type)
          this.$refs['modal-topup-balance-monit'].getDataXendit()
        })
        .catch(error => {
          const { message } = error.response.data.meta

          const errorKey = {
            'wrong pin numbers': 'PIN Tidak Sesuai',
            'have a pending disbursement': 'Terdapat transaksi yang belum selesai. Harap tunggu sampai transaksi selesai.',
            'destination account monit not found': 'Rekening tujuan tidak ditemukan',
            'amount is higher than the limit': 'Nominal melebihi limit. Harap cek syarat dan ketentuan transaksi.',
          }

          const messageError = errorKey[message] || `Topup saldo ${IDR(nominal)} gagal`

          this.$toast_error({ title: 'Gagal', message: messageError })
        })
        .finally(() => {
          this.topupData = null
          this.$refs['modal-topup-balance-monit'].resetData()
          this.selectedBalance = {}
        })
    },
  },
}
</script>

<style scoped>
.custom-select {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}

.bg-revenue {
  background: url('https://storage.googleapis.com/komerce/komads-meta/bg-komads.svg')
      no-repeat right top 90px,
    #FDFDFD;
  background-size: 550px;
}

.decreased {
  background-color: #e31a1a;
  color: white;
  width: fit-content;
}

.increased-revenue {
  background-color: #34a770;
  color: white;
  width: fit-content;
}

.decreased-second {
  background-color: #fcbebe;
  color: #e31a1a;
  width: fit-content;
}

.increased-second {
  background-color: #befcde;
  color: #34a770;
  width: fit-content;
}

.balance-actions .btn {
  border-radius: .75rem;
}

.balance-actions .btn-link {
  color: black;
  border: 1.5px solid #ddd;
}

.balance-actions .btn-link:hover {
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2) !important;
}
</style>
